export const en = {
    'cant-read-unexpected-data': 'Invalid data structure',
    'required-not-empty-field':
        'Required field must have a non-empty value. Column: {columns}, cell address: {address}',
    'unknown-error-text': 'An error occurred. Try again later.',
    'wrong-value-format': 'Invalid value'
};
